import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useMediaQuery } from 'react-responsive';

import PortraitGrid from '../../../assets/images/reference/grid_768.png';
import LandscapeGrid from '../../../assets/images/reference/grid_1272.png';

import Frame from '../../../assets/images/frames/desktop/360layoutrevised-1.jpg';

import './Frames.scss';

const Frames = data => {
  const isInitialized = useSelector(state => state.data.initialized);
  const isDebug = useSelector(state => state.config.debug);
  const [gridVisibility, setGridVisibility] = useState(false);
  const [frameVisibility, setFrameVisibility] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1272px)',
  });

  useEffect(() => {
    function Keydown(e) {
      if (isDebug && e.key === 'g') {
        setGridVisibility(!gridVisibility);
      }
      if (isDebug && e.key === 'f') {
        setFrameVisibility(!frameVisibility);
      }
    }

    document.addEventListener('keydown', Keydown, { passive: true });

    return () => {
      document.removeEventListener('keydown', Keydown);
    };
  }, [gridVisibility, frameVisibility]);

  if (isInitialized === false || isDebug === false) {
    return null;
  }

  var grid = null;

  if (gridVisibility) {
    grid = isDesktopOrLaptop ? (
      <img id="grid-landscape" className="grid" src={LandscapeGrid} alt="" />
    ) : (
      <img id="grid-portrait" className="grid" src={PortraitGrid} alt="" />
    );
  }

  var frame = null;

  if (frameVisibility) {
    frame = isDesktopOrLaptop ? (
      <img id="frame-landscape" className="grid" src={Frame} alt="" />
    ) : (
      <img id="frame-portrait" className="grid" src={Frame} alt="" />
    );
  }

  return (
    <div className="frames">
      {grid}
      {frame}
    </div>
  );
};

export default Frames;
